import { EGarageStatus } from '../../../../json_query';
import { changeGarageStatus } from '../../../state/advanced/garage_status';
import { getMultiSelectParam } from './abstract_params/multi_select_param';

export const GarageStatusParam = getMultiSelectParam<EGarageStatus>(
  'Статус',
  [
    { title: 'Собственность', value: EGarageStatus.Ownership },
    { title: 'Кооператив', value: EGarageStatus.Cooperative },
    { title: 'По доверенности', value: EGarageStatus.Agreement },
  ],
  'garage_status',
  changeGarageStatus,
);
